import type { SvgIconProps } from "@mui/material";
import { SvgIcon } from "@mui/material";
import type { FunctionComponent } from "react";

export const StrapiIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} width="89" height="87" viewBox="0 0 89 87">
      <path
        d="M86.2918 0H28.4541V28.9994H56.913C57.9269 28.9994 58.7494 29.8219 58.7494 30.8358V58.9019H88.1282V1.83974C88.1291 1.35212 87.936 0.884166 87.5915 0.539051C87.247 0.193936 86.7794 0 86.2918 0V0Z"
        fill="#8E75FF"
      />
      <path
        opacity="0.405"
        d="M28.4505 0V28.9994H1.31768C0.94484 28.9988 0.609273 28.7731 0.468016 28.4281C0.32676 28.083 0.407756 27.6868 0.673101 27.4249L28.4505 0ZM60.3136 86.3571C60.0495 86.6165 59.6555 86.6923 59.314 86.5494C58.9724 86.4065 58.7498 86.0727 58.7492 85.7024V58.9019H88.128L60.3136 86.3537V86.3571Z"
        fill="#8E75FF"
      />
      <path
        opacity="0.405"
        d="M28.4502 28.9994H57.8323C58.3359 28.9994 58.7489 29.409 58.7489 29.9159V58.9019H30.2899C29.2757 58.9019 28.4536 58.0797 28.4536 57.0655V28.9994H28.4502Z"
        fill="#8E75FF"
      />
    </SvgIcon>
  );
};
